export const JSON_ONE41 = {
   
  
    "error_code": "NO_DATA_FOUND",
    "error_message": "No Data found for given input. Please try again with other input details"
        }

